class AssociatedFilesRequestDto {
  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";
}

class AssociatedFilesResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 文件类型 1:客户信息附件 2:客户报价附件 */
  fileCategory = undefined;

  /** 文件名称 */
  fileName = "";

  /** 文件地址 */
  fileUrl = "";

  /** id */
  id = undefined;

  /** 版本号 */
  lockVersion = undefined;

  /** 来源唯一标识：客户id，报价code */
  sourceId = "";

  /** 修改人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class CustomerInvoiceDetailDto {
  /** 审批未收总额 */
  approveUnpaidAmount = undefined;

  /** 订单已收总额 */
  paidAmount = undefined;

  /** 收款状态 2待收款 3部分收款 4已收款 */
  paymentStatus = undefined;

  /** 订单含税总额 */
  taxTotalAmount = undefined;

  /** 剩余未收总额 */
  unpaidAmount = undefined;
}

class CustomerOrderAllDetailResponseRpcDto {
  /** 本司收款账户编号 */
  accountNo = "";

  /** 审批状态 1待提交 2审批中 3审批驳回 4审批通过 5已作废 */
  approvalStatus = undefined;

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 账期/天 */
  balanceDays = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 本司收款账户 */
  bankAccount = "";

  /** 银行账户ns编码 */
  bankAccountNsId = "";

  /** 本司收款银行/支行 */
  bankName = "";

  /** 线下销售订单号 */
  boOrderNo = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 国家 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentHandler = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 客户收货地址 */
  customerDeliveryAddress = "";

  /** 客户id */
  customerId = "";

  /** 客户名称 */
  customerName = "";

  /** 删除标识 */
  deleted = undefined;

  /** 要求发货时间 */
  deliveryTime = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 发起人姓名 */
  initiatorName = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 运费保险 */
  insuranceExpenses = undefined;

  /** 作废理由 */
  invalidNote = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 其他渠道备注 */
  logisticsChannelRemark = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 物流费用 */
  logisticsExpenses = undefined;

  /** 订单明细 */
  orderItemResponseRpcDtoList = [];

  /** 订单总数 */
  orderTotal = undefined;

  /** 其他费用金额 */
  otherExpenses = undefined;

  /** 其他费用备注 */
  otherRemark = "";

  /** 出货仓 */
  outWarehouse = "";

  /** 出货仓编码 */
  outWarehouseCode = "";

  /** 应收账单列表 */
  paymentOrderResponseRpcDtoList = [];

  /** 收款状态 1待请款 2待收款 3部分收款 4已收款 */
  paymentStatus = undefined;

  /** 平台类别 */
  platform = "";

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";

  /** 推送到oms状态 0未推送 1已推送 2推送失败 */
  pushOmsStatus = undefined;

  /** 推送时间 */
  pushOmsTime = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 销售类型 1折扣类型 2 常规销售 */
  saleType = undefined;

  /** 结算方式 1:账期 2:现结 */
  settlement = undefined;

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 发货状态 1待发货 2部分发货 3已发货 */
  shippingStatus = undefined;

  /** 系统订单号 */
  soOrderNo = "";

  /** 贸易术语 */
  standardTradeTerms = "";

  /** 税率 */
  taxRate = undefined;

  /** 含税总金额 */
  taxTotalAmount = undefined;

  /** 交易主体简称 */
  transactionMainAbbreviation = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class CustomerOrderCancelRequestDto {
  /** 订单编号 */
  boOrderNo = "";

  /** 作废备注 */
  invalidNote = "";
}

class CustomerOrderDetailResponseDto {
  /** 本司收款账户编号 */
  accountNo = "";

  /** 审批状态 1待提交 2审批中 3审批驳回 4审批通过 5已作废 */
  approvalStatus = undefined;

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 账期/天 */
  balanceDays = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 本司收款账户 */
  bankAccount = "";

  /** 银行账户ns编码 */
  bankAccountNsId = "";

  /** 本司收款银行/支行 */
  bankName = "";

  /** 线下销售订单号 */
  boOrderNo = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 合同文件名称 */
  contractFileName = "";

  /** 合同文件地址 */
  contractFileUrl = "";

  /** 国家 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 是否可创建预收款 1可创建 0不可创建 */
  createAdvanceStatus = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentHandler = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 客户收货地址 */
  customerDeliveryAddress = "";

  /** 客户id */
  customerId = "";

  /** 收款开票信息 */
  customerInvoiceDetailDto = new CustomerInvoiceDetailDto();

  /** 客户名称 */
  customerName = "";

  /** 订单明细 */
  customerOrderItemDetailResponseDtoList = [];

  /** 出货单 */
  customerOrderPackageDetailResponseDtoList = [];

  /** 删除标识 */
  deleted = undefined;

  /** 要求发货时间 */
  deliveryTime = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 发起人姓名 */
  initiatorName = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 运费保险 */
  insuranceExpenses = undefined;

  /** 作废理由 */
  invalidNote = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 其他渠道备注 */
  logisticsChannelRemark = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 物流费用 */
  logisticsExpenses = undefined;

  /** 订单总数 */
  orderTotal = undefined;

  /** 其他费用金额 */
  otherExpenses = undefined;

  /** 其他费用备注 */
  otherRemark = "";

  /** 出货仓 */
  outWarehouse = "";

  /** 出货仓编码 */
  outWarehouseCode = "";

  /** 收款状态 1待请款 2待收款 3部分收款 4已收款 */
  paymentStatus = undefined;

  /** 平台类别 */
  platform = "";

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";

  /** 推送到oms状态 0未推送 1已推送 2推送失败 */
  pushOmsStatus = undefined;

  /** 推送时间 */
  pushOmsTime = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 销售类型 1折扣类型 2 常规销售 */
  saleType = undefined;

  /** 结算方式 1:账期 2:现结 */
  settlement = undefined;

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 发货状态 1待发货 2部分发货 3已发货 */
  shippingStatus = undefined;

  /** 系统订单号 */
  soOrderNo = "";

  /** 贸易术语 */
  standardTradeTerms = "";

  /** 税率 */
  taxRate = undefined;

  /** 含税总金额 */
  taxTotalAmount = undefined;

  /** 交易主体简称 */
  transactionMainAbbreviation = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class CustomerOrderDetailResponseRpcDto {
  /** 本司收款账户编号 */
  accountNo = "";

  /** 审批状态 1待提交 2审批中 3审批驳回 4审批通过 5已作废 */
  approvalStatus = undefined;

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 账期/天 */
  balanceDays = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 本司收款账户 */
  bankAccount = "";

  /** 银行账户ns编码 */
  bankAccountNsId = "";

  /** 本司收款银行/支行 */
  bankName = "";

  /** 线下销售订单号 */
  boOrderNo = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 国家 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentHandler = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 客户收货地址 */
  customerDeliveryAddress = "";

  /** 客户id */
  customerId = "";

  /** 客户名称 */
  customerName = "";

  /** 删除标识 */
  deleted = undefined;

  /** 要求发货时间 */
  deliveryTime = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 发起人姓名 */
  initiatorName = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 运费保险 */
  insuranceExpenses = undefined;

  /** 作废理由 */
  invalidNote = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 其他渠道备注 */
  logisticsChannelRemark = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 物流费用 */
  logisticsExpenses = undefined;

  /** 订单明细 */
  orderItemResponseRpcDtoList = [];

  /** 订单总数 */
  orderTotal = undefined;

  /** 其他费用金额 */
  otherExpenses = undefined;

  /** 其他费用备注 */
  otherRemark = "";

  /** 出货仓 */
  outWarehouse = "";

  /** 出货仓编码 */
  outWarehouseCode = "";

  /** 收款状态 1待请款 2待收款 3部分收款 4已收款 */
  paymentStatus = undefined;

  /** 平台类别 */
  platform = "";

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";

  /** 推送到oms状态 0未推送 1已推送 2推送失败 */
  pushOmsStatus = undefined;

  /** 推送时间 */
  pushOmsTime = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 销售类型 1折扣类型 2 常规销售 */
  saleType = undefined;

  /** 结算方式 1:账期 2:现结 */
  settlement = undefined;

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 发货状态 1待发货 2部分发货 3已发货 */
  shippingStatus = undefined;

  /** 系统订单号 */
  soOrderNo = "";

  /** 贸易术语 */
  standardTradeTerms = "";

  /** 税率 */
  taxRate = undefined;

  /** 含税总金额 */
  taxTotalAmount = undefined;

  /** 交易主体简称 */
  transactionMainAbbreviation = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class CustomerOrderImportSkuResResponseDto {
  /** 失败日志 */
  errorList = [];

  /** 导入结果 */
  resFlag = false;

  /** 成功结果 */
  successList = [];
}

class CustomerOrderImportSkuResponseDto {
  /** 业务状态 DVT、PVT、MP、EOS、EOM、EOP、EOS */
  bizStatus = "";

  /** bom附件链接 */
  bomFileUrl = "";

  /** 描述 */
  description = "";

  /** 预计量产结束日期 */
  endTime = "";

  /** 预计量产 */
  estimatedProduct = "";

  /** id */
  id = undefined;

  /** 图片链接 */
  imageUrl = "";

  /** 资料是否完整 0: 是，1：否 */
  informationCompleteFlag = undefined;

  /** 数据状态 正在工作、正在审核、已发布 */
  lifecycle = "";

  /** 物流分组编号 */
  logisticsGroupNo = "";

  /** plmSkuBillingResponseDto */
  plmSkuBillingResponseDto = new PlmSkuBillingResponseRpcDto();

  /** 报关信息 */
  plmSkuCustomsClearanceResponseDto = new PlmSkuCustomsClearanceResponseRpcDto();

  /** sku管理信息 */
  plmSkuManageResponseDto = new PlmSkuManageResponseRpcDto();

  /** sku包装信息 */
  plmSkuPackageResponseDto = new PlmSkuPackageResponseRpcDto();

  /** sku供应商信息 */
  plmSkuVendorResponseDto = new PlmSkuVendorResponseRpcDto();

  /** spu简要信息 */
  plmSpuBriefInfoResponseDto = new PlmSpuBriefInfoResponseRpcDto();

  /** 销售价格 */
  price = undefined;

  /** 是否产品化管理 0: 是，1：否 */
  productManagementFlag = undefined;

  /** 产品模式 OEM、联合开发、自主研发 */
  productModel = "";

  /** 产品类型 成品、物料 */
  productType = "";

  /** 采购属性 */
  purchaseProperty = "";

  /** 销售数量 */
  quantity = undefined;

  /** 销售地区,多值（英文分号拼接） */
  salesTerritory = "";

  /** sku名称（CN） */
  skuNameCn = "";

  /** sku名称（EN） */
  skuNameEn = "";

  /** sku编码 */
  skuNo = "";

  /** 库存 */
  stock = undefined;

  /** 单位 */
  unit = "";

  /** 版本号 */
  version = "";
}

class CustomerOrderItemRequestDto {
  /** BU */
  bu = "";

  /** 海关要素NO */
  cino = "";

  /** 申报名称 */
  declareNameCn = "";

  /** 折扣率 */
  discountPercentage = undefined;

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 实际金额 */
  price = undefined;

  /** 销售数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** sku标题 */
  skuTitleCn = "";

  /** 库存 */
  stock = undefined;

  /** 含税单价 */
  taxPrice = undefined;
}

class CustomerOrderItemResponseDto {
  /** 线下销售订单号 */
  boOrderNo = "";

  /** BU */
  bu = "";

  /** 海关要素NO */
  cino = "";

  /** 币种 */
  currency = "";

  /** 申报名称 */
  declareNameCn = "";

  /** 折扣率 */
  discountPercentage = undefined;

  /** id */
  id = undefined;

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 商品支付价格 */
  itemPayPrice = undefined;

  /** 未出货量 */
  notDispatchedQty = undefined;

  /** 未出货金额 */
  notDispatchedTotalAmount = undefined;

  /** 实际金额（销售含税单价*折扣率*销售数量） */
  price = undefined;

  /** 销售数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 已出货量 */
  shippedQty = undefined;

  /** 已出货金额 */
  shippedTotalAmount = undefined;

  /** sku */
  sku = "";

  /** sku标题 */
  skuTitleCn = "";

  /** 库存 */
  stock = undefined;

  /** 税额 */
  taxAmount = undefined;

  /** 含税单价 */
  taxPrice = undefined;

  /** 未税单价 */
  unTaxAmount = undefined;
}

class CustomerOrderItemResponseRpcDto {
  /** 线下销售订单号 */
  boOrderNo = "";

  /** BU */
  bu = "";

  /** 海关要素NO */
  cino = "";

  /** 币种 */
  currency = "";

  /** 申报名称 */
  declareNameCn = "";

  /** 折扣率 */
  discountPercentage = undefined;

  /** id */
  id = undefined;

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 商品支付价格 */
  itemPayPrice = undefined;

  /** 未出货量 */
  notDispatchedQty = undefined;

  /** 未出货金额 */
  notDispatchedTotalAmount = undefined;

  /** 实际金额（销售含税单价*折扣率*销售数量） */
  price = undefined;

  /** 销售数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** 已出货量 */
  shippedQty = undefined;

  /** 已出货金额 */
  shippedTotalAmount = undefined;

  /** sku */
  sku = "";

  /** sku标题 */
  skuTitleCn = "";

  /** 库存 */
  stock = undefined;

  /** 税额 */
  taxAmount = undefined;

  /** 含税单价 */
  taxPrice = undefined;

  /** 未税单价 */
  unTaxAmount = undefined;
}

class CustomerOrderPackageDetailItemResponseDto {
  /** 出库金额 */
  outMasterTotal = undefined;

  /** 包裹item编号 */
  pioItemNo = "";

  /** 包裹单item类型 */
  pioType = undefined;

  /** 采购数量 */
  purchaseQty = undefined;

  /** 出库数量 */
  quantity = undefined;

  /** 销售金额 */
  saleTotal = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 平台订单商品号 */
  spItemNo = "";
}

class CustomerOrderPackageDetailResponseDto {
  /** 出货单明细 */
  customerOrderPackageDetailItemDtoList = [];

  /** 发货时间 */
  logisticsDeliveryTime = "";

  /** 物流单号 */
  logisticsTrackingNo = "";

  /** 包裹单 */
  opNo = "";

  /** 包裹状态 */
  opStatus = undefined;

  /** 包裹重量(g) */
  opWeight = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class CustomerOrderReceiptDetailVo {
  /** 本次申请金额 */
  appliedAmount = undefined;

  /** 本次已收金额 */
  appliedPaidAmount = undefined;

  /** 本次申请类型 */
  appliedType = undefined;

  /** 本次未收金额 */
  appliedUnpaidAmount = undefined;

  /** 审批状态 1:审批中 2:审批完成 3:已驳回 4:已作废 */
  approvalStatus = undefined;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 当前处理人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 客户ID */
  customerId = "";

  /** 期望收款日期 */
  expectedPaymentTime = "";

  /** 应收单号 */
  pano = "";

  /** 收款状态 1:未收款 2:部分收款 3:已收款 */
  paymentStatus = undefined;

  /** 更新时间 */
  updateTime = "";
}

class CustomerOrderRequestDto {
  /** 本司收款账户 */
  accountNo = "";

  /** 账期/天 */
  balanceDays = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 本司收款账户 */
  bankAccount = "";

  /** 银行账户ns编码 */
  bankAccountNsId = "";

  /** 本司收款银行/支行 */
  bankName = "";

  /** 销售订单号 */
  boOrderNo = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 合同文件名称 */
  contractFileName = "";

  /** 合同文件地址 */
  contractFileUrl = "";

  /** 国家 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 币种 */
  currency = "";

  /** 客户收货地址 */
  customerDeliveryAddress = "";

  /** 客户id */
  customerId = "";

  /** 客户名称 */
  customerName = "";

  /** 订单明细 */
  customerOrderItemRequestDtoList = [];

  /** 要求发货时间 */
  deliveryTime = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** 运费保险 */
  insuranceExpenses = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 其他渠道备注 */
  logisticsChannelRemark = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 物流费用 */
  logisticsExpenses = undefined;

  /** 其他费用金额 */
  otherExpenses = undefined;

  /** 其他费用备注 */
  otherRemark = "";

  /** 出货仓 */
  outWarehouse = "";

  /** 出货仓编码 */
  outWarehouseCode = "";

  /** 平台类别 */
  platform = "";

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";

  /** 销售类型 1折扣类型 2 常规销售 */
  saleType = undefined;

  /** 结算方式 1:账期 2:现结 */
  settlement = undefined;

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 贸易术语 */
  standardTradeTerms = "";

  /** 含税总金额 */
  taxTotalAmount = undefined;

  /** 交易主体简称 */
  transactionMainAbbreviation = "";

  /** 交易主体code NSID */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";
}

class CustomerOrderResponseDto {
  /** 本司收款账户编号 */
  accountNo = "";

  /** 审批状态 1待提交 2审批中 3审批驳回 4审批通过 5已作废 */
  approvalStatus = undefined;

  /** 审批时间 */
  approveTime = "";

  /** 审批人 */
  approver = "";

  /** 账期/天 */
  balanceDays = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 本司收款账户 */
  bankAccount = "";

  /** 银行账户ns编码 */
  bankAccountNsId = "";

  /** 本司收款银行/支行 */
  bankName = "";

  /** 线下销售订单号 */
  boOrderNo = "";

  /** 开户行市级代码 */
  cityCode = "";

  /** 开户行市级名称 */
  cityName = "";

  /** 国家 */
  country = "";

  /** 国家编码 */
  countryCode = "";

  /** 创建人 */
  createBy = "";

  /** 创建人名称 */
  createByName = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前处理人 */
  currentHandler = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 客户收货地址 */
  customerDeliveryAddress = "";

  /** 客户id */
  customerId = "";

  /** 客户名称 */
  customerName = "";

  /** 删除标识 */
  deleted = undefined;

  /** 要求发货时间 */
  deliveryTime = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 发起人姓名 */
  initiatorName = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 运费保险 */
  insuranceExpenses = undefined;

  /** 作废理由 */
  invalidNote = "";

  /** 版本 */
  lockVersion = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 其他渠道备注 */
  logisticsChannelRemark = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 物流费用 */
  logisticsExpenses = undefined;

  /** 订单总数 */
  orderTotal = undefined;

  /** 其他费用金额 */
  otherExpenses = undefined;

  /** 其他费用备注 */
  otherRemark = "";

  /** 出货仓 */
  outWarehouse = "";

  /** 出货仓编码 */
  outWarehouseCode = "";

  /** 收款状态 1待请款 2待收款 3部分收款 4已收款 */
  paymentStatus = undefined;

  /** 平台类别 */
  platform = "";

  /** 开户行省级代码 */
  provinceCode = "";

  /** 开户行省级名称 */
  provinceName = "";

  /** 推送到oms状态 0未推送 1已推送 2推送失败 */
  pushOmsStatus = undefined;

  /** 推送时间 */
  pushOmsTime = "";

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 销售类型 1折扣类型 2 常规销售 */
  saleType = undefined;

  /** 结算方式 1:账期 2:现结 */
  settlement = undefined;

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 发货状态 1待发货 2部分发货 3已发货 */
  shippingStatus = undefined;

  /** 系统订单号 */
  soOrderNo = "";

  /** 贸易术语 */
  standardTradeTerms = "";

  /** 税率 */
  taxRate = undefined;

  /** 含税总金额 */
  taxTotalAmount = undefined;

  /** 交易主体简称 */
  transactionMainAbbreviation = "";

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 修改人 */
  updateBy = "";

  /** 修改人名称 */
  updateByName = "";

  /** 修改时间 */
  updateTime = "";
}

class CustomerOrderStatementManagementResponseDto {
  /** 账期/天 */
  balanceDays = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 线下销售订单号 */
  boOrderNo = "";

  /** 国家 */
  country = "";

  /** 创建时间 */
  createTime = "";

  /** 客户收货地址 */
  customerDeliveryAddress = "";

  /** 客户id */
  customerId = "";

  /** sku编码 */
  customerSkuNo = "";

  /** 要求发货时间 */
  deliveryTime = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** 仓库首次完成拣货时间 */
  finishPickingTime = "";

  /** 仓库首次实际出货时间 */
  firstActualDeliveryTime = "";

  /** 首个包裹创建时间 */
  firstArticleCreateTime = "";

  /** 仓库首次拣货时间 */
  firstPickUpTime = "";

  /** id */
  id = undefined;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 物流渠道编码 */
  logisticsChannelCode = "";

  /** 物流商 */
  logisticsCompany = "";

  /** 物流商编码 */
  logisticsCompanyCode = "";

  /** 出货仓 */
  outWarehouse = "";

  /** 已出货数 */
  outboundQty = undefined;

  /** 是否可发货  0否 1是 2推送失败 */
  pushOmsStatus = undefined;

  /** 销售数量 */
  qty = undefined;

  /** 销售类型 1折扣类型 2 常规销售 */
  saleType = undefined;

  /** 结算方式 1:账期 2:现结 */
  settlement = undefined;

  /** 结算方式明细 */
  settlementDetail = undefined;

  /** 发货状态 1待发货 2部分发货 3已发货 */
  shippingStatus = undefined;

  /** sku */
  sku = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 贸易术语 */
  standardTradeTerms = "";

  /** 更新时间 */
  updateTime = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class PaymentDepositRecordsRequestDto {
  /** 本次收款金额 */
  paidPrice = undefined;

  /** 实际收款日期 */
  paidTime = "";

  /** 应收账单号 */
  pano = "";

  /** 水单列表 */
  receiptFileList = [];
}

class PaymentDepositRecordsResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 收款金额 */
  paidPrice = undefined;

  /** 收款时间 */
  paidTime = "";

  /** 应收账单号 */
  pano = "";

  /** 水单列表 */
  receiptFileList = [];

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PaymentOrderApprovalRequestDto {
  /** 审批状态 2通过 3驳回 */
  approvalStatus = undefined;

  /** 应付账单单号 */
  pano = "";

  /** 驳回备注 */
  rejectTimeReason = "";
}

class PaymentOrderCommitApprovalRequestDto {
  /** 期望收款日期 */
  expectedPaymentTime = "";

  /** 应付账单单号 */
  pano = "";
}

class PaymentOrderCreateResponseDto {
  /** 审批未收总额 */
  approveUnpaidAmount = undefined;

  /** 账期/天 */
  balanceDays = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 线下销售订单号 */
  boOrderNo = "";

  /** 币种 */
  currency = "";

  /** 客户id */
  customerId = "";

  /** 定金比例 */
  depositRatio = undefined;

  /** 期望收款日期 */
  expectedPaymentTime = "";

  /** 盖章合同 */
  orderContractList = [];

  /** 订单明细 */
  orderItemList = [];

  /** 本司收款账户 */
  ourBankAccountName = "";

  /** 本司收款账号 */
  ourBankAccountNumber = "";

  /** 本司收款银行/支行 */
  ourBankName = "";

  /** 订单已收总额 */
  paidAmount = undefined;

  /** 结算方式 1:账期 2:现结 */
  settlement = undefined;

  /** 订单含税总额 */
  taxTotalAmount = undefined;

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 剩余未收总额 */
  unpaidAmount = undefined;
}

class PaymentOrderInvalidApprovalRequestDto {
  /** 应付账单单号 */
  pano = "";

  /** 作废备注 */
  rejectTimeReason = "";
}

class PaymentOrderItemResponseDto {
  /** BU */
  bu = "";

  /** 海关要素NO */
  cino = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 申报名称 */
  declareNameCn = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** sku图片地址 */
  image = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 版本 */
  lockVersion = undefined;

  /** 已出库金额 */
  outboundAmount = undefined;

  /** 已出库数量 */
  outboundQty = undefined;

  /** 本次收款金额 */
  paidAmount = undefined;

  /** 本次收款数量 */
  paidQty = undefined;

  /** 应收账单号 */
  pano = "";

  /** 实际金额（销售含税单价*折扣率*销售数量） */
  price = undefined;

  /** 销售数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** sku标题 */
  skuTitleCn = "";

  /** 销售含税单价 */
  taxPrice = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PaymentOrderItemResponseRpcDto {
  /** BU */
  bu = "";

  /** 海关要素NO */
  cino = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 申报名称 */
  declareNameCn = "";

  /** 删除标识 */
  deleted = undefined;

  /** id */
  id = undefined;

  /** sku图片地址 */
  image = "";

  /** 开票单位 */
  invoiceUnitNo = "";

  /** 版本 */
  lockVersion = undefined;

  /** 已出库金额 */
  outboundAmount = undefined;

  /** 已出库数量 */
  outboundQty = undefined;

  /** 本次收款金额 */
  paidAmount = undefined;

  /** 本次收款数量 */
  paidQty = undefined;

  /** 应收账单号 */
  pano = "";

  /** 实际金额（销售含税单价*折扣率*销售数量） */
  price = undefined;

  /** 销售数量 */
  qty = undefined;

  /** 备注 */
  remark = "";

  /** sku */
  sku = "";

  /** sku标题 */
  skuTitleCn = "";

  /** 销售含税单价 */
  taxPrice = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PaymentOrderRequestDto {
  /** 本次申请金额 */
  appliedAmount = undefined;

  /** 本次申请类型 1:预收款 2:应收款 3:预发货 */
  appliedType = undefined;

  /** 线下销售订单号 */
  boOrderNo = "";

  /** 期望收款日期 */
  expectedPaymentTime = "";

  /** 包裹单号 */
  opno = "";
}

class PaymentOrderResponseDto {
  /** 本次实际收款额（应收款） */
  actualAmount = undefined;

  /** 本次申请金额 */
  appliedAmount = undefined;

  /** 本次申请已收 */
  appliedPaidAmount = undefined;

  /** 本次申请类型 1:预收款 2:应收款 */
  appliedType = undefined;

  /** 本次申请未收 */
  appliedUnpaidAmount = undefined;

  /** 审批状态 1:审批中 2:审批完成 3:已驳回 4:已作废 */
  approvalStatus = undefined;

  /** 审批时间 */
  approveTime = "";

  /** 审批未收总额（预收款） */
  approveUnpaidAmount = undefined;

  /** 审批人 */
  approver = "";

  /** 审批人姓名 */
  approverName = "";

  /** 账期/天 */
  balanceDays = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 线下销售订单号 */
  boOrderNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前负责人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 客户id */
  customerId = "";

  /** 删除标识 */
  deleted = undefined;

  /** 定金比例 */
  depositRatio = undefined;

  /** 收款记录 */
  depositRecordsList = [];

  /** 期望收款日期 */
  expectedPaymentTime = "";

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 发起人姓名 */
  initiatorName = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 版本 */
  lockVersion = undefined;

  /** 盖章合同 */
  orderContractList = [];

  /** 订单明细 */
  orderItemList = [];

  /** 本司收款账户 */
  ourBankAccountName = "";

  /** 本司收款账号 */
  ourBankAccountNumber = "";

  /** 本司收款银行/支行 */
  ourBankName = "";

  /** 订单已收总额（预收款） */
  paidAmount = undefined;

  /** 应收账单号 */
  pano = "";

  /** 收款状态 1:未收款 2:部分收款 3:已收款 */
  paymentStatus = undefined;

  /** 本次应收总额（应收款） */
  receivableAmount = undefined;

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 驳回人姓名 */
  rejectorName = "";

  /** 结算方式 1:账期 2:现结 */
  settlement = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 订单含税总额（预收款） */
  taxTotalAmount = undefined;

  /** 订单已冲销额（应收款） */
  totalWriteOffAmount = undefined;

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 剩余未收总额（预收款） */
  unpaidAmount = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 本次冲销总额（应收款） */
  writeOffAmount = undefined;
}

class PaymentOrderResponseRpcDto {
  /** 本次实际收款额（应收款） */
  actualAmount = undefined;

  /** 本次申请金额 */
  appliedAmount = undefined;

  /** 本次申请已收 */
  appliedPaidAmount = undefined;

  /** 本次申请类型 1:预收款 2:应收款 */
  appliedType = undefined;

  /** 本次申请未收 */
  appliedUnpaidAmount = undefined;

  /** 审批状态 1:审批中 2:审批完成 3:已驳回 4:已作废 */
  approvalStatus = undefined;

  /** 审批时间 */
  approveTime = "";

  /** 审批未收总额（预收款） */
  approveUnpaidAmount = undefined;

  /** 审批人 */
  approver = "";

  /** 审批人姓名 */
  approverName = "";

  /** 账期/天 */
  balanceDays = undefined;

  /** 尾款比例 */
  balanceRatio = undefined;

  /** 线下销售订单号 */
  boOrderNo = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 当前审核状态 */
  currentApprovalStatus = "";

  /** 当前审批步骤 */
  currentApprovalSteps = "";

  /** 当前负责人 */
  currentProcessor = "";

  /** 当前处理人编号 */
  currentProcessorCode = "";

  /** 当前处理人类型：指定人、指定角色 */
  currentProcessorType = "";

  /** 客户id */
  customerId = "";

  /** 删除标识 */
  deleted = undefined;

  /** 定金比例 */
  depositRatio = undefined;

  /** 期望收款日期 */
  expectedPaymentTime = "";

  /** id */
  id = undefined;

  /** 发起时间 */
  initiateTime = "";

  /** 发起人 */
  initiator = "";

  /** 发起人姓名 */
  initiatorName = "";

  /** 工作流实例ID */
  instanceId = "";

  /** 版本 */
  lockVersion = undefined;

  /** 订单明细 */
  orderItemList = [];

  /** 本司收款账户 */
  ourBankAccountName = "";

  /** 本司收款账号 */
  ourBankAccountNumber = "";

  /** 本司收款银行/支行 */
  ourBankName = "";

  /** 订单已收总额（预收款） */
  paidAmount = undefined;

  /** 应收账单号 */
  pano = "";

  /** 收款状态 1:未收款 2:部分收款 3:已收款 */
  paymentStatus = undefined;

  /** 本次应收总额（应收款） */
  receivableAmount = undefined;

  /** 驳回时间 */
  rejectTime = "";

  /** 驳回原因 */
  rejectTimeReason = "";

  /** 驳回人 */
  rejector = "";

  /** 驳回人姓名 */
  rejectorName = "";

  /** 结算方式 1:账期 2:现结 */
  settlement = undefined;

  /** 来源单号 */
  sourceNo = "";

  /** 订单含税总额（预收款） */
  taxTotalAmount = undefined;

  /** 订单已冲销额（应收款） */
  totalWriteOffAmount = undefined;

  /** 交易主体code */
  transactionMainCode = "";

  /** 交易主体名称 */
  transactionMainName = "";

  /** 剩余未收总额（预收款） */
  unpaidAmount = undefined;

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 本次冲销总额（应收款） */
  writeOffAmount = undefined;
}

class PlmSkuBillingResponseRpcDto {
  /** 海关要素NO */
  cino = "";

  /** 是否商检 */
  commodityInspectionFlag = false;

  /** 法定海关单位 */
  customsUnitName = "";

  /** 申报名称（CN） */
  declareNameCn = "";

  /** 申报名称（EN） */
  declareNameEn = "";

  /** HSCODE(国内) */
  hscodeCn = "";

  /** 开票单位 */
  invoiceUnitName = "";

  /** 产品型号 */
  skuModel = "";

  /** 出口退税率 */
  taxRebateRate = undefined;
}

class PlmSkuCustomsClearanceResponseRpcDto {
  /** 产品认证类型 */
  certificationType = "";

  /** 海关监管条件 */
  customsControl = "";

  /** 申报要素 */
  declareMemo = "";

  /** 是否申报型号 */
  declareTypeFlag = undefined;

  /** 检疫检验类别 */
  inspectionType = "";

  /** 产品材质名称（CN） */
  materialNameCn = "";

  /** 产品材质名称（EN） */
  materialNameEn = "";

  /** 海关要素明细 */
  plmSkuCustomsResponseDtos = [];

  /** 产品用途（CN） */
  productUseCn = "";

  /** 产品用途（EN） */
  productUseEn = "";
}

class PlmSkuCustomsResponseRpcDto {
  /** 是否反倾销 */
  antiDumpingFlag = undefined;

  /** 反倾销税 */
  antiDumpingRate = undefined;

  /** 中文名称 */
  countryNameCn = "";

  /** 海关编码 */
  hscodeCn = "";

  /** id */
  id = undefined;

  /** 国家二字码 */
  secondWord = "";

  /** SKU编号 */
  skuNo = "";

  /** 关税率 */
  tariffRate = undefined;
}

class PlmSkuManageResponseRpcDto {
  /** 需求计划员 */
  demandPlanner = "";

  /** 产品负责人 */
  productOwner = "";

  /** 项目经理 */
  projectManager = "";

  /** 采购负责人 */
  purchaser = "";

  /** 供应计划员 */
  supplyPlanner = "";
}

class PlmSkuPackageResponseRpcDto {
  /** 装箱高 */
  boxHeightCm = undefined;

  /** 装箱长 */
  boxLongCm = undefined;

  /** 每箱数量（MPQ） */
  boxMpq = undefined;

  /** 装箱宽 */
  boxWidthCm = undefined;

  /** 商品尺寸 */
  commoditySize = "";

  /** 产品高 */
  heightCm = undefined;

  /** 产品长 */
  longCm = undefined;

  /** 产品包装高 */
  packHeightCm = undefined;

  /** 产品包装长 */
  packLongCm = undefined;

  /** 产品包装重量（g） */
  packWeight = undefined;

  /** 产品包装宽 */
  packWidthCm = undefined;

  /** 单箱计费重（G） */
  singleBillingWeight = undefined;

  /** 装箱体积 */
  singleBoxVolume = undefined;

  /** 单箱体积重(G)' */
  singleBoxVolumeWeight = undefined;

  /** 单箱净重(G) */
  singleBoxWeight = undefined;

  /** 单箱毛重(G) */
  singleGrossWeight = undefined;

  /** 产品本体净重（g） */
  weight = undefined;

  /** 产品宽 */
  widthCm = undefined;
}

class PlmSkuVendorResponseRpcDto {
  /** id */
  id = undefined;

  /** 最小供应商moq */
  minMoq = undefined;

  /** 物流周期 */
  productionCycle = undefined;

  /** 供应商ID=Code+交易主体缩写+供应商名称 */
  supplierIdName = "";
}

class PlmSpuBriefInfoResponseRpcDto {
  /** 品牌编号 */
  brandNo = "";

  /** 产品线，乐器，户外，文创，其他 */
  buCode = "";

  /** 一级品类 */
  primaryProductLine = "";

  /** 一级品类名称 */
  primaryProductLineName = "";

  /** 二级品类 */
  secondaryProductLine = "";

  /** 二级品类名称 */
  secondaryProductLineName = "";

  /** spu名称（CN） */
  spuNameCn = "";

  /** spu名称（EN） */
  spuNameEn = "";

  /** spu编码 */
  spuNo = "";

  /** 三级品类 */
  tertiaryProductLine = "";

  /** 三级品类名称 */
  tertiaryProductLineName = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new CustomerOrderAllDetailResponseRpcDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class TheExaminationAndApprovalParameters {
  /** 审批状态 3审批驳回 4审批通过 */
  approvalStatus = undefined;

  /** 线下销售单号 */
  boOrderNo = "";

  /** 驳回备注 */
  rejectRemark = "";
}

export const business = {
  AssociatedFilesRequestDto,
  AssociatedFilesResponseDto,
  CustomerInvoiceDetailDto,
  CustomerOrderAllDetailResponseRpcDto,
  CustomerOrderCancelRequestDto,
  CustomerOrderDetailResponseDto,
  CustomerOrderDetailResponseRpcDto,
  CustomerOrderImportSkuResResponseDto,
  CustomerOrderImportSkuResponseDto,
  CustomerOrderItemRequestDto,
  CustomerOrderItemResponseDto,
  CustomerOrderItemResponseRpcDto,
  CustomerOrderPackageDetailItemResponseDto,
  CustomerOrderPackageDetailResponseDto,
  CustomerOrderReceiptDetailVo,
  CustomerOrderRequestDto,
  CustomerOrderResponseDto,
  CustomerOrderStatementManagementResponseDto,
  IPage,
  PaymentDepositRecordsRequestDto,
  PaymentDepositRecordsResponseDto,
  PaymentOrderApprovalRequestDto,
  PaymentOrderCommitApprovalRequestDto,
  PaymentOrderCreateResponseDto,
  PaymentOrderInvalidApprovalRequestDto,
  PaymentOrderItemResponseDto,
  PaymentOrderItemResponseRpcDto,
  PaymentOrderRequestDto,
  PaymentOrderResponseDto,
  PaymentOrderResponseRpcDto,
  PlmSkuBillingResponseRpcDto,
  PlmSkuCustomsClearanceResponseRpcDto,
  PlmSkuCustomsResponseRpcDto,
  PlmSkuManageResponseRpcDto,
  PlmSkuPackageResponseRpcDto,
  PlmSkuVendorResponseRpcDto,
  PlmSpuBriefInfoResponseRpcDto,
  Response,
  ResponseDto,
  TheExaminationAndApprovalParameters,
};
